module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('btn-options', {
    attrs: {
      "title": "Configurações gerenciais de usuário",
      "options": _vm.options
    },
    on: {
      "openConfiguracoesACL": _vm.openConfiguracaoACL,
      "openConfiguracaoAcessoPatio": _vm.openRelacionarUsuarioPatio,
      "openConfiguracaoAcessoContrato": _vm.openRelacionarUsuarioContrato,
      "openAtendenteReboquistaForm": function($event) {
        return _vm.$emit('openAtendenteReboquistaForm')
      }
    }
  }), _vm._v(" "), (_vm.showConfiguracaoACL) ? _c('popup-viewer', {
    attrs: {
      "title": ("Configuração de ACL de " + (_vm.user.username))
    },
    on: {
      "close": _vm.closeConfiguracaoACL
    }
  }, [_c('configuracao-usuario-acl', {
    attrs: {
      "acls": _vm.user.acl
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRelacionarUsuarioPatio) ? _c('popup-viewer', {
    attrs: {
      "title": "Gerenciar pátios do usuário"
    },
    on: {
      "close": _vm.closeRelacionarUsuarioPatio
    }
  }, [_c('usuario-patios', {
    attrs: {
      "patios-usuario": _vm.user.patios
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRelacionarUsuarioContrato) ? _c('popup-viewer', {
    attrs: {
      "title": "Gerenciar contratos do usuário"
    },
    on: {
      "close": _vm.closeRelacionarUsuarioContrato
    }
  }, [_c('usuario-contratos', {
    attrs: {
      "contratos-usuario": _vm.user.contratos
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71ce7af4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/usuarios/components/BtnUsuarioConfiguracoesGerenciais.vue
// module id = 1766
// module chunks = 17